import { GeneralButton } from '@/interfaces';
import { ButtonEvents } from '@shopee/chatbot-ui/lib/types';

export enum ButtonTypeV1 {
  PRIMARY = 1,
  PRIMARY_DISABLED,
  PRIMARY_OUTLINED,
  SECONDARY,
  SECONDARY_DISABLED,
  FRAMELESS,
  FRAMELESS_DISABLED,
  TRADITIONAL,
  TRADITIONAL_DISABLED,
  ORDINARY_SELECTOR,
}

export enum ButtonType {
  Default,
  Primary,
  PrimaryOutlined,
  SecondaryOutlined,
  Frameless,
  Ordinary,
  Link = 1000,
  Text,
}

export enum ButtonAction {
  JumpURL = 1,
  JumpNode,
  JumpFormstack,
  ShowAgentQueue,
  GetIntent,
  CancelOrder,
  ExtendShopeeGuarantee,
  Login,
  ClickIntent,
  ClickSubIntent,
  ClickQAButton,
  ClickTaskBot,

  // 对应v1的按钮类型
  SubmitFeedback = 10000,
  PopArticle,
  MoreOrder,
  // 暂不支持的按钮类型
  Unsupport = 100000,
}

export enum ButtonActionV1 {
  LIVE = 'btn_live',
  REDIRECTION = 'btn_redirection',
  TASKBOT = 'btn_taskbot',
  CANCEL_ORDER = 'btn_cancel_order',
  ACTIVATE_SHOPEEPAY = 'btn_activate_shopeepay',
  // ARTICLE = 'btn_article',
  FEEDBACK = 'btn_feedback',
  MODAL = 'btn_modal',
  POP_ARTICLE = 'btn_pop_article',
  MORE_ORDER = 'btn_more_order',
  LOGIN = 'btn_login',
  KB_INTENT = 'btn_kb_intent',
  NUDGE_CASE = 'btn_case_nudge',
}

function hyphenate(str: string) {
  if (typeof str !== 'string') {
    return '';
  }

  const hyphenateRE = /\B([A-Z])/g;
  return str.replace(hyphenateRE, '-$1').toLowerCase();
}

export const compatibleButtonType: { [key in ButtonTypeV1]: ButtonType } = {
  [ButtonTypeV1.PRIMARY]: ButtonType.Primary,
  [ButtonTypeV1.PRIMARY_DISABLED]: ButtonType.Primary,
  [ButtonTypeV1.PRIMARY_OUTLINED]: ButtonType.PrimaryOutlined,
  [ButtonTypeV1.SECONDARY]: ButtonType.SecondaryOutlined,
  [ButtonTypeV1.SECONDARY_DISABLED]: ButtonType.SecondaryOutlined,
  [ButtonTypeV1.FRAMELESS]: ButtonType.Frameless,
  [ButtonTypeV1.FRAMELESS_DISABLED]: ButtonType.Frameless,
  [ButtonTypeV1.TRADITIONAL]: ButtonType.Default,
  [ButtonTypeV1.TRADITIONAL_DISABLED]: ButtonType.Default,
  [ButtonTypeV1.ORDINARY_SELECTOR]: ButtonType.Ordinary,
};

export const compatibleButtonAction: { [key in ButtonActionV1]: ButtonAction } = {
  [ButtonActionV1.KB_INTENT]: ButtonAction.GetIntent,
  [ButtonActionV1.LIVE]: ButtonAction.ShowAgentQueue,
  [ButtonActionV1.REDIRECTION]: ButtonAction.JumpURL,
  [ButtonActionV1.TASKBOT]: ButtonAction.JumpNode,
  [ButtonActionV1.FEEDBACK]: ButtonAction.SubmitFeedback,
  [ButtonActionV1.POP_ARTICLE]: ButtonAction.PopArticle,
  [ButtonActionV1.MORE_ORDER]: ButtonAction.MoreOrder,
  [ButtonActionV1.LOGIN]: ButtonAction.Login,
  [ButtonActionV1.CANCEL_ORDER]: ButtonAction.CancelOrder,
  [ButtonActionV1.ACTIVATE_SHOPEEPAY]: ButtonAction.Unsupport,
  [ButtonActionV1.MODAL]: ButtonAction.Unsupport,
  // [ButtonActionV1.ARTICLE]: ButtonAction.Unsupport,
  [ButtonActionV1.NUDGE_CASE]: ButtonAction.JumpNode,
};

export function getButtonType(type: ButtonType) {
  if (!Object.values(ButtonType).includes(type)) {
    return 'default';
  }

  return hyphenate(ButtonType[type]);
}

export function getButtonTypeV1(type: ButtonTypeV1) {
  return getButtonType(compatibleButtonType[type]);
}

export function getButtonAction(action: ButtonAction) {
  const buttonActionMap = {
    [ButtonAction.JumpURL]: ButtonEvents.Redirection,
    [ButtonAction.JumpFormstack]: ButtonEvents.Redirection,
    [ButtonAction.JumpNode]: ButtonEvents.Next,
    [ButtonAction.GetIntent]: ButtonEvents.GetIntent,
    [ButtonAction.ShowAgentQueue]: ButtonEvents.ToLiveAgent,
    [ButtonAction.CancelOrder]: ButtonEvents.CancelOrder,
    [ButtonAction.ExtendShopeeGuarantee]: ButtonEvents.ExtendShopeeGuarantee,
    [ButtonAction.Login]: ButtonEvents.Login,
    [ButtonAction.ClickIntent]: ButtonEvents.ClickIntent,
    [ButtonAction.ClickSubIntent]: ButtonEvents.ClickSubIntent,
    [ButtonAction.SubmitFeedback]: ButtonEvents.SubmitFeedback,
    [ButtonAction.PopArticle]: ButtonEvents.PopArticle,
    [ButtonAction.MoreOrder]: ButtonEvents.MoreOrder,
    [ButtonAction.Unsupport]: ButtonEvents.Unsupport,
    [ButtonAction.ClickQAButton]: ButtonEvents.ClickQAButton,
    [ButtonAction.ClickTaskBot]: ButtonEvents.ClickTaskBot,
  };

  return buttonActionMap[action];
}

export function getButtonActionV1(action: ButtonActionV1) {
  return getButtonAction(compatibleButtonAction[action]);
}

export function getButtonDataV1(
  button: GeneralButton,
) {
  if (!button.button_type) { return {}; }
  const getButtonData: {
    [key in ButtonActionV1]?: () => any;
  } = {
    // TODO: 其他待补充
    [ButtonActionV1.KB_INTENT]: () => ({ nextParams: button.query_callback }),
    [ButtonActionV1.NUDGE_CASE]: () => ({ }),
    [ButtonActionV1.REDIRECTION]: () => ({
      url_info: {
        url: button.url,
        uri_key: button.uri_key,
        uri_extra: button.uri_extra,
      }
    }),
  };

  return getButtonData?.[button.button_type as ButtonActionV1]?.() || {};
}
